import { useAuth } from "@app/hooks"
import { App } from "@app/interfaces"
import { hasAccessPolicy } from "@app/utils"

/** Tracking uses the backend's global roles; accountId is never an ACL. */
export const useTrackingWriteAccess = () =>
  hasAccessPolicy(App.AccessPolicy.USERBOT_TRACKING_WRITE, useAuth())
